const editorData = {
    en: {
        loading: {
            fetching: 'Loading data...',
            saving: 'Saving...',
            updating: 'Updating...',
            deleting: 'Deleting...',
        },
        header: {
            manageContent: 'Manage and edit the content for this section.',
            editableFields: 'Editable Fields',
            readOnly: 'Read Only',
            none: '— None —',
            editingDisabled: 'Editing is disabled for this section.',
            back: 'Back',
            addNew: '+ Add New',
        },
        card: {
            noImage: 'No Image',
            edit: 'Edit',
            clone: 'Clone',
            delete: 'Delete',
            itemsCount: 'Items',
            objectLabel: '{Object}',
        },
        modal: {
            title: 'Edit Item',
            cancel: 'Discard Changes',
            save: 'Save Registry',
            typeLabel: 'Type',
            jsonMode: 'Edit Raw JSON',
            doneJson: 'Apply Changes',
            formatJson: 'Format JSON',
            navigation: 'Navigation',
            generalSettings: 'General Settings',
            imagePlaceholder: 'Paste image URL...',
            uploadHelp: 'Upload to generate Base64/URL',
            invalidJson: 'Invalid JSON Syntax',
            fixErrors: 'Forbidden: Missing keys:',
            removeImage: 'Remove Image',
            noImageSelected: 'No image selected',
            uploading: 'Uploading...',
            or: 'OR',
            browseGallery: 'Browse Gallery',
            pasteUrlPlaceholder: 'Or paste an image URL directly...',
        },
        gallery: {
            title: 'Media Library',
            subtitle: 'Select an image to use, or manage your existing assets.',
            noAssets: 'No assets found. Upload an image in the editor to add it to your Media Library.',
            selectImage: 'Select Image',
            deleteConfirm: 'Are you sure you want to remove this image from the registry?',
            deleteFailed: 'Failed to delete asset.',
        },
        alerts: {
            deleteConfirm: 'Delete this item?',
            minItems: 'Must keep at least one item. Deletion cancelled.',
            saveFailed: 'Save failed',
            uploadFailed: 'Failed to upload image. Please try again.',
        },
        emptyState: 'No records in this section yet.',
    },
    he: {
        loading: {
            fetching: 'טוען נתונים...',
            saving: 'שומר...',
            updating: 'מעדכן...',
            deleting: 'מוחק...',
        },
        header: {
            manageContent: 'נהל וערוך את התוכן עבור המקטע הזה.',
            editableFields: 'שדות ניתנים לעריכה',
            readOnly: 'לקריאה בלבד',
            none: '— אין —',
            editingDisabled: 'העריכה מושבתת למקטע זה.',
            back: 'חזרה',
            addNew: '+ הוסף חדש',
        },
        card: {
            noImage: 'אין תמונה',
            edit: 'ערוך',
            clone: 'שכפל',
            delete: 'מחק',
            itemsCount: 'פריטים',
            objectLabel: '{אובייקט}',
        },
        modal: {
            title: 'עריכת פריט',
            cancel: 'בטל שינויים',
            save: 'שמור רשומה',
            typeLabel: 'סוג',
            jsonMode: 'ערוך JSON גולמי',
            doneJson: 'החל שינויים',
            formatJson: 'פרמוט JSON',
            navigation: 'ניווט',
            generalSettings: 'הגדרות כלליות',
            imagePlaceholder: 'הדבק כתובת תמונה...',
            uploadHelp: 'ניתן להדביק URL או להעלות קובץ',
            invalidJson: 'תחביר JSON לא תקין',
            fixErrors: 'פעולה אסורה: חסרים שדות:',
            removeImage: 'הסר תמונה',
            noImageSelected: 'לא נבחרה תמונה',
            uploading: 'מעלה...',
            or: 'או',
            browseGallery: 'עיון בגלריה',
            pasteUrlPlaceholder: 'או הדבק כתובת תמונה ישירות...',
        },
        gallery: {
            title: 'ספריית מדיה',
            subtitle: 'בחר תמונה לשימוש, או נהל את הנכסים הקיימים שלך.',
            noAssets: 'לא נמצאו נכסים. העלה תמונה בעורך כדי להוסיף אותה לספריית המדיה שלך.',
            selectImage: 'בחר תמונה',
            deleteConfirm: 'האם אתה בטוח שברצונך להסיר תמונה זו מהמערכת?',
            deleteFailed: 'מחיקת הנכס נכשלה.',
        },
        alerts: {
            deleteConfirm: 'למחוק את הפריט הנבחר?',
            minItems: 'חייב להישאר לפחות פריט אחד. המחיקה בוטלה.',
            saveFailed: 'השמירה נכשלה',
            uploadFailed: 'העלאת התמונה נכשלה. אנא נסה שוב.',
        },
        emptyState: 'אין רשומות במקטע זה עדיין.',
    },
};

export function getEditorStrings(language) {
    return editorData[language] || editorData.en;
}

export default editorData;